// extracted by mini-css-extract-plugin
export default {"initialMessageTextArea":"CheckoutCustomStripePaymentForm_initialMessageTextArea__ZaBE9"};